// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bg-4";
export var collapsed = "_bg-1";
export var headerBar = "_bg-0";
export var leftHeaderContent = "_bg-3";
export var subjectContainer = "_bg-2";